import React from "react";
import {Translate, withLocalize} from "react-localize-redux";
import * as actions from "../../store/actions/actions";
import {connect} from "react-redux";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";
import { UncontrolledDropdown } from "reactstrap";

import italianLanguageTranslations from "../../translations/language/it.language.json";
import englishLanguageTranslations from "../../translations/language/en.language.json";

class LanguageToggle extends React.Component {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianLanguageTranslations, "it");
    this.props.addTranslationForLanguage(englishLanguageTranslations, "en");
  }

  changeLanguage = (languageCode) => {
    this.props.changeLanguage(languageCode);
    this.props.setActiveLanguage(languageCode)
  }


  render() {
    return(
      <Translate>
        {({ translate }) =>
          <UncontrolledDropdown>
        <DropdownToggle caret  drop={"left"}>
          {this.props.languages.filter(lang => lang.active === true).map(lang => lang.code.toUpperCase())}
        </DropdownToggle>
        <DropdownMenu right>
          {this.props.languages.map((item)=>{
            return <DropdownItem key={item.code} onClick={() => this.changeLanguage(item.code)}>
              <span>{translate(item.code)}</span>
            </DropdownItem>

          })}
        </DropdownMenu>
      </UncontrolledDropdown>}
      </Translate>
  )
  }
}

const mapStateToProps = state => {
  return {
    languages: state.localize.languages
  }
}

const mapDispatchToProps = dispatch => {
  return {
    login: (data) => dispatch({type: actions.AUTHENTICATION_LOGIN_REQUEST, value: data}),
    changeLanguage: (langId) => dispatch({type: actions.CHANGE_LANGUAGE_REQUEST, value: langId})
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(LanguageToggle));